import type { CISProviderBehavior } from '../types';

export const conEdCISBehavior: CISProviderBehavior = {
	label: 'ConEd',
	supportsCardSwipe: false,
};
